import { type InputSourceValues } from "./invocationSpecSchema";

/**
 * What each kind of input is called and what it mounts: the "Add input" menu
 * offers it in these words, and the row it adds is titled in them.
 */
export const INPUT_SOURCE_COPY = {
  dataset: {
    title: "Files from a dataset",
    description: "Pick a dataset and a file glob; those files are mounted.",
  },
  "triggering-dataset": {
    title: "Files from the triggering dataset",
    description:
      "Pick a file glob; those files are mounted from the dataset that changed.",
  },
  query: {
    title: "Files matching a query",
    description: "Write a RoboQL query; every file it returns is mounted.",
  },
} as const satisfies Record<
  InputSourceValues["source"],
  { title: string; description: string }
>;

/** What the firing is about, for a row that mounts the dataset it carries. */
export type TriggeringSubject = "file" | "dataset";

/**
 * The dataset in the words of the firing at hand.
 *
 * A file firing has no triggering dataset to speak of -- the thing that fired
 * is a file -- so the row has to name the dataset as that file's, or it claims
 * a subject the trigger does not have.
 */
export function triggeringDatasetCopy(subject: TriggeringSubject) {
  if (subject === "file") {
    return {
      title: "Files from the triggering file's dataset",
      description:
        "Pick a file glob; those files are mounted from the dataset the file that fired is in.",
    };
  }
  return INPUT_SOURCE_COPY["triggering-dataset"];
}
